module.exports = __webpack_public_path__ + "static/media/retiro_carbon.2b76cff3.png";